import api from './api';
import type {
  AssetFilterOptions,
  AssetQueryParams,
  InstalledAsset,
  InstalledAssetDetail,
  PaginatedAssetsResponse
} from '@/types/asset';

class AssetService {
  private baseUrl = '/api/installed-assets';

  // Paginated, filtered, sorted list — backs the DataTable
  async getAssets(params: AssetQueryParams): Promise<PaginatedAssetsResponse> {
    const response = await api.get(this.baseUrl, { params });
    return response.data.data;
  }

  // Same filters, unpaginated (backend-capped) — used to build CSV/Excel/PDF exports
  async exportAssets(params: Omit<AssetQueryParams, 'page' | 'limit'>): Promise<InstalledAsset[]> {
    const response = await api.get(`${this.baseUrl}/export`, { params });
    return response.data.data.assets;
  }

  async getFilterOptions(): Promise<AssetFilterOptions> {
    const response = await api.get(`${this.baseUrl}/filter-options`);
    return response.data.data;
  }

  async getAssetById(assetId: string): Promise<InstalledAssetDetail> {
    const response = await api.get(`${this.baseUrl}/${assetId}`);
    return response.data.data;
  }
}

export const assetService = new AssetService();
